import { Box, Typography } from '@mui/material';
import React from 'react';
import { BreadCrumbsAndTitle } from '../../../components/generics/BreadCrumbsAndTitle';
import { AlertsInformativos } from '../../../components/generics/AlertsInformativos';
import { alertInformativo } from '../../../commons/texts/textAlertsInformativos';
import { BannerInfoConfiguracion } from './components/BannerInfoConfiguracion';
import { ReviewLinksCard } from './components/ReviewLinks/ReviewLinksCard';
import { WhatsappTemplatesCard } from './components/ReviewLinks/WhatsappTemplatesCard';

export const ConfiguracionPlantillaResenas = () => {

    return (
        <Box sx={{ p: 3, margin: '0 auto' }}>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Box>
                    <BreadCrumbsAndTitle
                        title="Plantillas y Redes Sociales" 
                        mainModule="calificaciones" 
                        parent="Configuraciones"
                        action="Plantillas de Reseñas" 
                        icon="Link"
                    />
                    
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        <AlertsInformativos type={'info'} title={'info'} content={alertInformativo.linksEncuestas} /> 
                    </Typography>
                </Box>
            </Box>

            <Box sx={{ display: 'flex', gap: 3, mb: 4 }}>
                <Box sx={{ flex: 1 }}>
                    <ReviewLinksCard />
                </Box>
                <Box sx={{ flex: 1 }}>
                    <WhatsappTemplatesCard />
                </Box>
            </Box>

            <BannerInfoConfiguracion />

        </Box>
    );
};
